// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Verse Card Component (Premium v2)
// ═══════════════════════════════════════════════════════════════════════════

import { symbols } from './icons.js';
import { SYMBOLS } from '../config/themes.js';
import { PROMPTS } from '../config/prompts.js';
import { escapeHtml } from '../utils/escape.js';

function getRandomSymbol() {
    if (!SYMBOLS.enabled) return null;
    if (Math.random() > SYMBOLS.probability) return null;

    const symbolList = SYMBOLS.list;
    const key = symbolList[Math.floor(Math.random() * symbolList.length)];
    return symbols[key] || null;
}

function getRandomPrompt(array) {
    return array[Math.floor(Math.random() * array.length)];
}

export function createVerseCard(verse, options = {}) {
    const { isDivine = false, divineCountdown = 0 } = options;

    const card = document.createElement('div');
    card.className = `verse-card ${isDivine ? 'divine-verse' : ''}`;
    card.dataset.reference = verse.reference;

    const symbol = getRandomSymbol();

    card.innerHTML = `
    <div class="verse-card-inner">
      ${isDivine ? `<div class="divine-prompt">${getRandomPrompt(PROMPTS.divineVerseIntro)}</div>` : ''}
      <p class="verse-text">${escapeHtml(verse.text)}</p>
      <p class="verse-reference">${escapeHtml(verse.reference)}</p>
      ${isDivine && divineCountdown > 0 ? `<div class="divine-timer">Pause · ${divineCountdown}s</div>` : ''}
      ${symbol ? `<div class="verse-symbol" aria-hidden="true">${symbol}</div>` : ''}
    </div>
  `;

    return card;
}

export function updateDivineTimer(card, seconds) {
    let timer = card.querySelector('.divine-timer');
    if (seconds > 0) {
        if (!timer) {
            timer = document.createElement('div');
            timer.className = 'divine-timer';
            const inner = card.querySelector('.verse-card-inner');
            if (inner) inner.appendChild(timer);
        }
        timer.textContent = `Pause · ${seconds}s`;
    } else if (timer) {
        timer.textContent = 'Breathe';
    }
}

export default createVerseCard;
